import { INSERT_RESOURCE_FAILED_HANDLER } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case INSERT_RESOURCE_FAILED_HANDLER:
      return action.payload;
    default:
      return state;
  }
};
